import { CloudEnvironmentConfig } from "../constants/AppConfigs";
import { IS_LOCALHOST, REACT_APP_ENDPOINT_ENV } from "../constants/Config";
import Logger from "./logHandlers/Logger";
import AppConfig from "../config/localConfig.json";

/**
 * Method to execute all init calls post config Load
 *
 */
export const initAfterConfigLoad = () => {
  Logger.suppressConsole();
};

/**
 * Returns environment-specific Tempo configuration values for local development.
 */
export const GetEnvVariables = () => {
  let envConfig = {};

  if (IS_LOCALHOST) {
    const selectedEndpointEnv = REACT_APP_ENDPOINT_ENV;
    switch (selectedEndpointEnv) {
      case CloudEnvironmentConfig.SB1:
        envConfig = AppConfig?.SB1 || {};
        break;
      case CloudEnvironmentConfig.QA1:
        envConfig = AppConfig?.QA1 || {};
        break;
      case CloudEnvironmentConfig.DEV1:
        envConfig = AppConfig?.DEV1 || {};
        break;
      case CloudEnvironmentConfig.SB2:
        envConfig = AppConfig?.SB2 || {};
        break;
      case CloudEnvironmentConfig.DEV2:
        envConfig = AppConfig?.DEV2 || {};
        break;
      case CloudEnvironmentConfig.QA2:
        envConfig = AppConfig?.QA2 || {};
        break;
        default:
    }
  }
  return envConfig;
};
